import mixins from 'vue-typed-mixins'
import { validationMixin } from 'vuelidate'
import startCase from 'lodash/startCase'
import capitalize from 'lodash/capitalize'

export default mixins( validationMixin).extend({
    methods: {
        isValidWithNotification(form: any): boolean {
            this.$v.$touch()

            try {
                if (this.$v !== undefined && this.$v !== null) {
                    if (form.$error) {
                        const entries = Object.entries(form)
                        for (const entry of entries) {
                            const entryItem: any = entry[1]
                            const startsWith = !entry[0].startsWith('$')
                            if (startsWith) {
                                if (entryItem && entryItem.$error) {
                                    const propName = startCase(entry[0].replace('ID', ''))

                                    if (entryItem.required === false || entryItem.requiredIf === false) {
                                        const message = `${propName} is required`
                                        //this.notifyError(message)
                                    }

                                    if ( entryItem.numeric === false ) {
                                        const message = `${propName} must be numeric`
                                    }

                                    if (entryItem.minValue == false) {
                                        const message = `${propName} minimum value is ${entryItem.$params.minValue.min}`
                                        //this.notifyError(message)
                                    }

                                    if (entryItem.minLength == false) {
                                        const message = `${propName} minimum length is ${entryItem.$params.minLength.min} characters`
                                        // this.notifyError(message)
                                    }

                                    if (entryItem.maxLength == false) {
                                        const message = `${propName} maximum length is ${entryItem.$params.maxLength.max} characters`
                                        // this.notifyError(message)
                                    }

                                    if (entryItem.email == false) {
                                        const message = `${propName} is invalid`
                                        // this.notifyError(message)
                                    }

                                    if (entryItem.url == false) {
                                        const message = `${propName} is invalid. Must be a fully qualified and valid URL (e.g. https://orbit.gvrd.bc.ca)`
                                        // this.notifyError(message)
                                    }

                                }
                            }
                        }
                        return false
                    } else {
                        return true
                    }
                }
                return false
            } catch (error) {
                return false
            }
        },
        validate({ obj, name, index = null, subName = null }: { obj: string, name: string, index?: number | null, subName?: string | null }): any[] {
            const errors: any[] = []
            if (this.$v[obj] && this.$v[obj][name] != undefined) {
                let validation: any = this.$v[obj][name]

                if (typeof validation === 'object' && index != null) {
                    validation = validation.$each[index]
                }

                if (typeof validation === 'object' && subName != null) {
                    validation = validation[subName]
                }

                if (validation === null || validation === undefined) return errors

                const propName = startCase(name.replace('ID', ''))

                if (!validation.$dirty) return errors

                let message = '';

                if (validation.required === false || validation.requiredIf === false) {
                    message = capitalize(`${propName} is required`)
                    errors.push(message)
                }

                if ( validation.numeric === false) {
                    message = capitalize( `${propName} must be numeric`)
                    errors.push(message)
                }

                if (validation.minValue !== undefined && validation.minValue === false) {
                    message = capitalize(`${propName} minimum value is ${validation.$params.minValue.min}`)
                    errors.push(message)
                }

                if (validation.minLength !== undefined && validation.minLength === false) {
                    message = capitalize(`${propName} minimum length is ${validation.$params.minLength.min}`)
                    errors.push(message)
                }

                if (validation.maxLength !== undefined && validation.maxLength === false) {
                    message = capitalize(`${propName} maximum length is ${validation.$params.maxLength.max}`)
                    errors.push(message)
                }

                if (validation.email !== undefined && validation.email === false) {
                    message = capitalize(`${propName} is invalid`)
                    errors.push(message)
                }

                if (validation.url !== undefined && validation.url === false) {
                    message = capitalize(`${propName} is invalid. Must be a fully qualified and valid URL (e.g. https://orbit.gvrd.bc.ca)`)
                    errors.push(message)
                }
            }
            return errors
        },
         validateMatchesPassword(value: any, data: { password: string | null; }) {
            return (value == data.password);
        },
        resetForm() {
            this.$v.$reset()
        }
    }
})
